import React, { type ReactNode } from 'react';
import classNames from 'classnames';

interface Props {
  children: ReactNode;
  className?: string;
}

export default function TabTitle({ children, className = 'mb-0' }: Props) {
  return <h5 className={classNames('fw-normal', className)}>{children}</h5>;
}
